import DetailFormHead from "components/subHead/detailFormHead";
import { useTranslation } from "react-i18next";

import { useGetData } from "./service";
import { useChange, useOnUpdate } from "./handles";
import Cell from "components/rows/cell";
import PhoneSelect from "components/select/phone/phone";
import Select from "components/select";
import TableRow from "components/rows/tableRow";

export type upInfProps = {
  mobNo: undefined | string;
  mobCntyCd: undefined | string;
  uYn: undefined | string;
};

export default function ManagerDetail() {
  const { t } = useTranslation();

  const { manInf } = useGetData();

  // joiReqDtti 승인
  const joiDtti = manInf?.joiReqDtti?.slice(0, 8) ?? "--";
  const lockDtti = manInf?.lckDtti?.slice(0, 8) ?? "--";

  const { upInf, onChange } = useChange();

  const { isAble, onUpdate } = useOnUpdate({ upInf, manNo: manInf?.manNo });

  const uYnDefault =
    manInf?.lckYn === "Y"
      ? manYns[3]
      : manInf?.soYn === "Y"
      ? manYns[2]
      : manInf?.joiAprYn === "Y"
      ? manYns[1]
      : manYns[0];

  return (
    <>
      {/* 기본정보 */}
      <DetailFormHead title={t("manager_detail_ttl")} />
      <table>
        <tbody>
          <TableRow title={t("manager_detailt_row_ttl")}>
            <ul>
              <li>
                <Cell label={t("lbl_mem_no_cmm")} value={manInf?.manNo} />
              </li>
              <li>
                <Cell label={t("lbl_en_sfnm_cmm")} value={manInf?.manSurnm} />
              </li>
              <li>
                <Cell label={t("lbl_en_fsnm_cmm")} value={manInf?.manFstnm} />
              </li>
              <li>
                <Cell label={t("lbl_sns_cmm")} value="--" />
              </li>
              <li>
                <Cell label={t("lbl_eml_id_cmm")} value={manInf?.emlId} />
              </li>
              <li>
                <Cell
                  label={t("lbl_user_nm_cmm")}
                  value={manInf?.manSurnm + " " + manInf?.manFstnm}
                />
              </li>

              <li>
                <Cell label={t("lbl_lng_cmm")} value={manInf?.langCd} />
              </li>
              <li>
                <Cell label={t("lbl_crr_cmm")} value={manInf?.currCd} />
              </li>
              <li>
                {!isAble && (
                  <Cell
                    label={t("lbl_country_no_cmm")}
                    value={manInf?.mobCntyCd}
                  />
                )}
                {isAble && (
                  <>
                    {/* 국가번호 선택 */}
                    <>
                      <label htmlFor="">{t("lbl_country_no_cmm")}</label>
                      <PhoneSelect
                        styles="flex-1 h-full bg-white border-gray-400"
                        ulStyles="top-[26px]"
                      />
                    </>
                  </>
                )}
              </li>
              <li>
                {!isAble && (
                  <Cell label={t("lbl_phone_cmm")} value={manInf?.mobNo} />
                )}
                {isAble && (
                  <>
                    <label htmlFor="">{t("lbl_phone_cmm")}</label>
                    <input
                      type="text"
                      name="mobNo"
                      value={upInf.mobNo || manInf?.mobNo}
                      onChange={onChange}
                    />
                  </>
                )}
              </li>
              <li>
                {!isAble && (
                  <Cell
                    label={t("lbl_stt_cmm")}
                    value={
                      manInf?.soYn === "Y"
                        ? t("user_withdrawn")
                        : manInf?.joiAprYn === "Y"
                        ? t("user_approval")
                        : manInf?.lckYn === "Y"
                        ? t("user_dormant")
                        : t("user_request")
                    }
                  />
                )}
                {isAble && (
                  <>
                    {/* 회원상태 선택 */}
                    <label htmlFor="">{t("lbl_stt_cmm")}</label>
                    <Select
                      options={manYns}
                      dataTyp="C"
                      isUpdateAble
                      defaultValue={uYnDefault}
                      styles="flex-1 bg-white border-1"
                      // ulStyles="top-[28px]"
                    />
                  </>
                )}
              </li>
              <li>
                <Cell label={t("lbl_joined_dt_cmm")} value={joiDtti} />
              </li>
              <li>
                <Cell label={t("lbl_deleted_dt_cmm")} value={lockDtti} />
              </li>
            </ul>
          </TableRow>
        </tbody>
      </table>
      <div className="flex justify-center mt-3">
        <button className="btn bg-red-400" onClick={onUpdate}>
          수정
        </button>
      </div>
    </>
  );
}

const manYns = [
  {
    ko: "신청",
    en: "requested",
    value: "Y",
    code: "joiAprYn",
  },
  {
    ko: "승인",
    en: "approval",
    value: "Y",
    code: "uYn",
  },
  {
    ko: "탈퇴",
    en: "withdrawn",
    value: "Y",
    code: "soYn",
  },
  {
    ko: "휴먼",
    en: "dormant",
    value: "Y",
    code: "lckYn",
  },
];
